import { render, staticRenderFns } from "./ReadBeneficiariosPrograma.vue?vue&type=template&id=33f08fe7"
import script from "./ReadBeneficiariosPrograma.vue?vue&type=script&lang=js"
export * from "./ReadBeneficiariosPrograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports